import { IGDPRInitialState } from "us.collection/reducers/GDPRComment/Interfaces";

export const initialState: IGDPRInitialState = {
  showGDPRCommentBox: false,
  showDashboard: false,
};
